import React from 'react'

export default function Wheel(props) {
  const inDistance = props?.distanceFromCrossing && props.distanceFromCrossing < 100 && props.distanceFromCrossing > 5 
   
  
  return (
    <div className="Wheel">
      <div className="speedometer digital">{props.speed} </div>
      {inDistance && <>
                    <div className={"countdownCaption"}>Distance</div>
                    <div className="countdown">{props.distanceFromCrossing} <small>FT</small></div>
          </>
      }
    </div>
  )
}